import { useSelector } from "react-redux";
import { selectScenarioEntityIds } from "state/scenario/selector";
import Mode from "state/selections/Mode";
import SelectionState from "./SelectionState";
import { selectCommittedEntities, selectSelectedEntityIds } from "./selector";

export const useQueryEnabled = () => {
  const { asOfDateEntity, groupTypeEntity, groupEntities, modeEntity } =
    useSelector(selectCommittedEntities);
  const selectedEntityIds = useSelector(
    selectSelectedEntityIds(SelectionState.COMMITTED)
  );
  const scenarioEntityIds = useSelector(selectScenarioEntityIds);

  switch (modeEntity.value) {
    default:
      throw Error(`Unknown mode ${modeEntity.value}`);
    case Mode.ACC_GROUPS:
      return asOfDateEntity && !!groupTypeEntity && groupEntities?.length > 0;
    case Mode.SCENARIOS:
      return asOfDateEntity && scenarioEntityIds?.length > 0;
    case Mode.ENTITIES:
      return asOfDateEntity && selectedEntityIds?.length > 0;
  }
};
